export default {
    manage_createEditAssetSubtype_editTitle: "Edit Asset Subtype",
    manage_createEditAssetSubtype_createTitle: "Create New Asset Subtype",
    manage_createEditAssetSubtype_createSuccess: "Asset Subtype saved",
    manage_createEditAssetSubtype_name: "Name",
    manage_createEditAssetSubtype_duplicatedName: "Name is already in use",
    manage_createEditAssetSubtype_are_in_use: "It is not possible to delete asset subtypes in use",
    manage_createEditAssetSubtype_successMessageCreate: "Asset subtype was created successfully",
    manage_createEditAssetSubtype_successMessageUpdate: "Asset subtype was updated successfully",
    manage_createEditAssetSubtype_searchTable: "Search by Name",
}